export const sizePerPageList = [
    { text: "3", value: 3 },
    { text: "5", value: 5 },
    { text: "10", value: 10 }
];

export const initialFilter = {
    filter: {
        name: "",
        type: "BANK_KURBAN",
        channel_name: "",
        status: "",
        start_date: "",
        end_date: ""
    },
    // sortOrder: "asc", // asc||desc
    // sortField: "VINCode",
    pageNumber: 1,
    pageSize: 10
};


export const statusList = [
    { value: "IMPORTED", name: "IMPORTED" },
    { value: "ON PROCESS", name: "ON PROCESS" },
    { value: "SETTLE", name: "SETTLE" }
]

export const badge = (status) => {
    let data = {};
    switch (status) {
        case 'VOID':
            data = { type: 'danger' };
            break;
        case 'REQUEST_VOID':
            data = { type: 'warning' };
            break;
        case 'SETTLE':
            data = { type: 'success' };
            break;
        default:
            data = { type: 'info' };

    }

    return data;
};